<template>
  <div id="report-detail">
    <dash-header
      :pages="breadCrumbsPages"
      :dashboardTitle="reportData.title.rendered"
      v-if="reportData.title"
    />
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="userRole === 'telas_course_submitters'"
      />
      <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.admin"
        v-if="userRole === 'telas_telas_administrator'"
      />
      <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.assessors"
        v-else
      />
      <a-layout-content
        :style="{
          margin: '24px 16px',
          padding: '24px',
          background: '#fff',
          minHeight: '280px',
        }"
      >
        <report-summary-card
          :reportId="reportId"
          :courseDetails="courseDetails"
          :style="{ marginBottom: '20px' }"
          :isComparative="false"
        />
        <a-card
          hoverable
          style="width: 100%"
          v-if="reportData.report_details !== undefined"
        >
          <template
            class="ant-card-actions"
            slot="actions"
            v-if="
              userRole === 'telas_telas_administrator' &&
              reportData.report_details.assessment_status === 'complete'
            "
          >
            <a-popconfirm
              v-if="isReportAccreditationMailSent"
              title="Mail has already been sent. Send again?"
              @confirm="sendSummaryReport"
              okText="Yes"
              cancelText="No"
            >
              <span :style="{ fontSize: '20px' }">
                Send Accreditation E-mail:
                <a-icon
                  theme="twoTone"
                  twoToneColor="#52c41a"
                  type="safety-certificate"
                />
              </span>
            </a-popconfirm>
            <span v-else @click="sendSummaryReport()" :style="{ fontSize: '20px' }">
              Send Summary Report email:
              <a-icon theme="twoTone" twoToneColor="#52c41a" type="safety-certificate" />
            </span>
          </template>
          <combined-review
            :combinedReviewObj="reportData"
            :oriFirstReviewerAnswerData="
              reportData.report_details.first_reviewer_assessment_data.review_data
            "
            :assessmentStatus="reportData.report_details.assessment_status"
            :firstReviewerId="reportData.report_details.first_reviewer_id"
            :adminAssessmentData="
              combinedReview.report_details.original_assessments_data.admin_reviewer_data
            "
            :firstAssessmentData="
              combinedReview.report_details.original_assessments_data.first_reviewer_data
            "
            :secondAssessmmentData="
              combinedReview.report_details.original_assessments_data.second_reviewer_data
            "
            :adminReviewerComments="
              combinedReview.report_details.original_assessments_data
                .admin_reviewer_comments
            "
            :firstReviewerComments="
              combinedReview.report_details.original_assessments_data
                .first_reviewer_comments
            "
            :secondReviewerComments="
              combinedReview.report_details.original_assessments_data
                .second_reviewer_comments
            "
            :comments="reviewComments"
            :admin_reassessment_comments="adminReassessmentComments"
            :reassessment_comments="reassessmentComments"
          ></combined-review>
        </a-card>
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script>
/* eslint-disable no-param-reassign */
import { mapState, mapActions, mapGetters } from "vuex";
import dashHeader from "@src/views/dashboard/Header.vue";
import dashSidebar from "@src/views/dashboard/Sidebar.vue";
import reportSummaryCard from "../report/Report-summary-card.vue";
import combinedReview from "../report/Combined-review.vue";

export default {
  name: "report-detail",
  data() {
    return {
      completed: false,
      reportId: this.$route.params.reportId,
      reportData: {},
      breadCrumbsPages: [
        {
          name: "Home",
          route: "/",
        },
        {
          name: "Dashboard",
          route: "/dashboard",
        },
        {
          name: "Combined Review",
          route: `/dashboard/report/${this.$route.params.reportId}`,
        },
      ],
      reviewComments: {
        standard_0_comment: "",
        standard_1_comment: "",
        standard_2_comment: "",
        standard_3_comment: "",
        standard_4_comment: "",
        standard_5_comment: "",
        standard_6_comment: "",
        standard_7_comment: "",
      },
      admin_reassessment_comments: {
        standard_0_comment: "",
        standard_1_comment: "",
        standard_2_comment: "",
        standard_3_comment: "",
        standard_4_comment: "",
        standard_5_comment: "",
        standard_6_comment: "",
        standard_7_comment: "",
      },
      reassessment_comments: {
        standard_0_comment: "",
        standard_1_comment: "",
        standard_2_comment: "",
        standard_3_comment: "",
        standard_4_comment: "",
        standard_5_comment: "",
        standard_6_comment: "",
        standard_7_comment: "",
      },
    };
  },
  components: {
    reportSummaryCard,
    combinedReview,
    dashHeader,
    dashSidebar,
  },
  computed: {
    ...mapState("assessments", {
      combinedReview: (state) => state.combinedReview,
    }),
    ...mapGetters("user", {
      userToken: "getUserToken",
      userRole: "getUserRole",
    }),
    ...mapGetters("assessments", {
      isReportAccreditationMailSent: "isReportAccreditationMailSent",
    }),
    ...mapState("courses", {
      courseDetails: (state) => state.courseDetails,
    }),
  },
  methods: {
    ...mapActions("assessments", {
      getReportById: "getReportById",
    }),
    ...mapActions("reports", {
      sendAccreditation: "sendAccreditation",
    }),
    ...mapActions("common", {
      clearSuccessMessage: "clearSuccessMessage",
    }),
    ...mapActions("courses", {
      getCourseById: "getCourseById",
    }),
    sendSummaryReport() {
      const courseId = this.reportData.report_details.course_id;
      this.sendAccreditation({ course_id: courseId, userToken: this.userToken });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.userToken !== undefined) {
        this.getReportById({
          reportId: this.reportId,
          userToken: this.userToken,
        });
      }
    });
  },
  created() {
    this.unsubscribeReport = this.$store.subscribe((mutation, state) => {
      // eslint-disable-next-line max-len
      switch (mutation.type) {
        case "assessments/REPORTFETCHED":
          this.reportData = state.assessments.combinedReview;
          // eslint-disable-next-line no-case-declarations
          const courseId = state.assessments.combinedReview.report_details.course_id;
          this.reviewComments = this.reportData.report_details.comments;
          this.adminReassessmentComments = this.reportData.report_details.admin_reassessment_comments;
          this.reassessmentComments = this.reportData.report_details.reassessment_comments;
          this.getCourseById({ courseId, userToken: this.userToken });
          break;
        case "assessments/REPORTUPDATED":
          this.reportData = state.assessments.combinedReview;
          if (this.reportData.report_details.combined_review_status === "in-progress") {
            this.$notification.success({
              message: "Saved",
              description: "You have saved the asessment.",
            });
          }
          if (this.reportData.report_details.combined_review_status === "completed") {
            this.sendAccreditation({
              course_id: this.reportData.report_details.course_id,
              userToken: this.userToken,
            });
            this.$notification.success({
              message: "Completed",
              description: "You have completed the assessment.",
            });
          }
          break;
        case "reports/SENDACCREDITATION":
          this.$message.success(
            state.common.messages.success,
            1,
            this.clearSuccessMessage()
          );
          break;
        default:
          // this.successFulLogin = false;
          break;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribeReport();
  },
  watch: {
    userToken() {
      this.getReportById({
        reportId: this.reportId,
        userToken: this.userToken,
      });
    },
  },
};
</script>
